import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useSession from "../../hooks/useSession";
import LoaderFilling from "../shared/Loader/LoaderFilling";
import { RoutePath } from "../../utilities/Constants";

function UserAuth({ children }) {
  const [user, loading] = useSession();
  const location = useLocation();
  const { platform } = RoutePath;

  if (loading) {
    return <LoaderFilling />;
  }

  if (user?.name) {
    return <Navigate to={`/${platform}`} state={{ from: location }} replace />;
  }

  return children;
}

export default UserAuth;
